import React from "react";
import { CASTILLA2, SITE, IMG } from "../lib/data";
import { ArrowRight, MapPin } from "lucide-react";

export default function ProyectosDisponibles() {
  return (
    <section
      id="proyectos"
      data-testid="proyectos-section"
      className="bg-[hsl(var(--hh-bone))] py-20 md:py-28 lg:py-32 border-t border-black/5"
    >
      <div className="container-hh">
        <div className="reveal max-w-2xl">
          <div className="flex items-center gap-3 sm:gap-4 mb-5 sm:mb-6">
            <span className="accent-line" />
            <span className="overline text-[hsl(var(--hh-moss))]" style={{ fontSize: "0.65rem" }}>
              Proyectos
            </span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-balance">
            Nuestros{" "}
            <em style={{ fontStyle: "italic", color: "hsl(var(--hh-moss))" }}>
              proyectos recientes.
            </em>
          </h2>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-12 gap-x-4 gap-y-8 md:gap-8">
          {/* Ariake — Featured */}
          <article
            data-testid="proyecto-card-ariake"
            className="group col-span-12 lg:col-span-8 overflow-hidden bg-white"
          >
            <a href="#ariake" className="block">
              <div className="relative aspect-[16/10] md:aspect-[16/9] overflow-hidden">
                <img
                  src={IMG.ariake.entranceClean}
                  alt="Ariake — casas independientes en Tumbaco sector Hilacril"
                  className="absolute inset-0 h-full w-full object-cover group-hover:scale-105 transition-transform duration-[1400ms]"
                />
                <div className="absolute top-4 left-4 bg-[hsl(var(--hh-sunrise))] text-black overline px-3 py-1.5" style={{ fontSize: "0.58rem" }}>
                  Proyecto destacado
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 to-transparent" />
                <div className="absolute bottom-0 inset-x-0 p-4 md:p-5 text-white flex items-center gap-2 overline" style={{ fontSize: "0.6rem" }}>
                  <MapPin size={12} /> Tumbaco · Hilacril
                </div>
              </div>
              <div className="p-6 md:p-9">
                <div className="flex items-baseline justify-between gap-3 flex-wrap">
                  <h3 className="font-display text-3xl md:text-4xl">ARIAKE</h3>
                  <span className="overline text-[hsl(var(--hh-moss))]" style={{ fontSize: "0.6rem" }}>
                    Disponible · 2026
                  </span>
                </div>
                <p className="font-display italic text-base md:text-lg mt-2" style={{ color: "hsl(var(--hh-moss))" }}>
                  Tu hogar, un nuevo amanecer.
                </p>
                <p className="mt-3 text-sm md:text-base text-[hsl(0,0%,30%)] leading-relaxed max-w-2xl">
                  Casas independientes de una sola planta. 130–140 m², 2 y 3 dormitorios.
                </p>
                <span className="mt-5 inline-flex items-center gap-2 overline text-[hsl(var(--hh-ink))]" style={{ fontSize: "0.62rem" }}>
                  Conocer Ariake <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                </span>
              </div>
            </a>
          </article>

          {/* Castilla 2 */}
          <article
            data-testid="proyecto-card-castilla2"
            className="group col-span-12 lg:col-span-4 overflow-hidden bg-white"
          >
            <a
              href={CASTILLA2.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="block"
              data-testid="proyecto-cta-castilla2"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={CASTILLA2.image}
                  alt="Conjunto Castilla 2 — casas esquineras en Tumbaco"
                  className="absolute inset-0 h-full w-full object-cover group-hover:scale-105 transition-transform duration-[1400ms]"
                />
                <div className="absolute top-4 left-4 bg-black text-white overline px-3 py-1.5" style={{ fontSize: "0.58rem" }}>
                  Entregado · 2024
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 to-transparent" />
                <div className="absolute bottom-0 inset-x-0 p-4 text-white flex items-center gap-2 overline" style={{ fontSize: "0.6rem" }}>
                  <MapPin size={12} /> Sector Tumbaco
                </div>
              </div>
              <div className="p-6 md:p-7">
                <h3 className="font-display text-2xl md:text-3xl">Conjunto Castilla 2</h3>
                <p className="mt-2 text-sm text-[hsl(0,0%,32%)] leading-relaxed">
                  Casas esquineras de dos plantas, 3 dormitorios y amplios patios privados.
                </p>
                <span className="mt-4 inline-flex items-center gap-2 overline text-[hsl(var(--hh-ink))]" style={{ fontSize: "0.62rem" }}>
                  Más información <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                </span>
              </div>
            </a>
          </article>
        </div>
      </div>
    </section>
  );
}
